'use strict';

const _=require('pulsar-utils/dist-es6/_');
const TripViewModel=require('./tripViewModel');let

FlightViewModel=class FlightViewModel extends TripViewModel{
constructor(jsonFlight){
super(jsonFlight);

this._jsonFlight=jsonFlight;
}

get crewRole(){
return this._jsonFlight.crewRole;
}

get crewCount(){
return this._jsonFlight.crewCount;
}

get isPositioning(){
return this._jsonFlight.isPositioning;
}

get restPeriod(){
return this._jsonFlight.restPeriod;
}

get toc(){
return this._jsonFlight.toc;
}

get tod(){
return this._jsonFlight.tod;
}

get metrics(){
return this._jsonFlight.metrics;
}

get highWorkloads(){
return this._jsonFlight.highWorkloads;
}};


module.exports=FlightViewModel;
//# sourceMappingURL=flightViewModel.js.map
